import addDataIcon from "../addData.svg";
import addTextIcon from "../addText.svg";
import chartIcon from "../chart.svg";
import joinDataIcon from "../joinData.svg";
import pageIcon from "../page.svg";
import favouriteIcon from "../favourites.svg";
import searchIcon from "../search.svg";

import barChartIcon from "../barchart.svg";
import boxPlotIcon from "../boxplot.svg";
import lineChartIcon from "../linechart.svg";
import pieChartIcon from "../piechart.svg";
import tableIcon from "../table.svg";

export const dataSidebar = [
  {
    id: 1,
    title: "Add Chart",
    icon: chartIcon,
    action: "openChartPopup",
  },
  {
    id: 2,
    title: "Add Text",
    icon: addTextIcon,
    action: null,
  },
  {
    id: 3,
    title: "Add Data",
    icon: addDataIcon,
    action: null,
  },
  {
    id: 4,
    title: "Join Data",
    icon: joinDataIcon,
    action: null,
  },
  {
    id: 5,
    title: "Page",
    icon: pageIcon,
    action: null,
  },
  {
    id: 6,
    title: "Favourites",
    icon: favouriteIcon,
    action: null,
  },
  {
    id: 7,
    title: "Zoom",
    icon: searchIcon,
    action: null,
  },
];

export const chartTypes = {
  Basic: [
    { id: "table", name: "Table", icon: tableIcon, category: "basic" },
    {
      id: "linechart",
      icon: lineChartIcon,
      name: "Line Chart",
      category: "basic",
    },
    {
      id: "barchart",
      icon: barChartIcon,
      name: "Bar Chart",
      category: "basic",
    },
    {
      id: "piechart",
      icon: pieChartIcon,
      name: "Pie Chart",
      category: "basic",
    },
    // { id: "scatter", name: "Scatter Plot", category: "basic" },
  ],
  Statistical: [
    { id: "boxplot", icon: boxPlotIcon, name: "Box Plot", category: "stats" },
    // { id: "histogram", name: "Histogram", category: "stats" },
  ],
  // Scientific: [
  //   { id: "timeseries", name: "Time Series", category: "scientific" },
  //   { id: "candlestick", name: "Candle Stick", category: "scientific" },
  // ],
  // Map: [{ id: "scattermap", name: "Scatter Map Plot", category: "map" }],
};
